import { StyleSheet } from "react-native";

const navigationStyles = StyleSheet.create({
  listItem: {
    height: 55,
    justifyContent: "center",
  },
});
export default navigationStyles;
